import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  features: string[];
  engagement: string;
  onConsultClick: () => void;
}

const ServiceCard = ({
  icon,
  title,
  description,
  features,
  engagement,
  onConsultClick,
}: ServiceCardProps) => {
  return (
    <div className="bg-card rounded-lg shadow-md hover:shadow-lg transition-all duration-base border border-border overflow-hidden group">
      <div className="p-6 md:p-8">
        <div className="flex items-start justify-between mb-6">
          <div className="w-14 h-14 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-base">
            <Icon name={icon as any} size={28} variant="solid" className="text-white" />
          </div>
          <span className="px-3 py-1 bg-brand-light text-brand-blue text-xs font-headline font-semibold rounded-full">
            {engagement}
          </span>
        </div>
        
        <h3 className="text-2xl font-headline font-bold text-foreground mb-3">
          {title}
        </h3>
        
        <p className="text-muted-foreground leading-relaxed mb-6">
          {description}
        </p>
        
        <div className="space-y-3 mb-6">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <Icon
                name="CheckCircleIcon"
                size={20}
                variant="solid"
                className="text-success flex-shrink-0 mt-0.5"
              />
              <span className="text-sm text-foreground">{feature}</span>
            </div>
          ))}
        </div>
        
        <button
          onClick={onConsultClick}
          className="w-full px-6 py-3 bg-conversion text-conversion-foreground font-headline font-semibold text-sm rounded-md hover:bg-opacity-90 shadow-cta hover:shadow-partnership transition-all duration-base transform hover:-translate-y-0.5"
        >
          Schedule Consultation
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;